module.exports = __webpack_public_path__ + "img/firebase-logo.bfa69c4f.svg";